import {
  SET_POSTS,
  LIKE_POST,
  UNLIKE_POST,
  //LOADING_DATA,
  DELETE_POST,
  POST_POST,
  SET_POST,
  SUBMIT_COMMENT,
  SET_PROFILE,
  //SET_SAVED_POSTS,
} from "../types";

const initialState = {
  // posts: [],
  // post: {},
  allPosts: [],
  currentPost: {},
  //loading: false,
  //savedPosts: [],
  currentProfile: {},
  likes: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    // case LOADING_DATA:
    //   return {
    //     ...state,
    //     loading: true,
    //   };
    case SET_POSTS:
    var allLikes = action.payload.allLikes;    
    var uniqueLikes = [];
    allLikes.map((likeO) => {      
      var likeIndex = uniqueLikes.findIndex((like) =>
        like.postId === likeO.postId && like.postId !== undefined
      );      
      if(likeIndex === -1) {
        if(likeO.postId !== undefined){
          uniqueLikes.push({postId: likeO.postId, handlesLiked: [likeO.userHandle]});
          //console.log(uniqueLikes)
        }
      }
      else {
        //console.log(likeIndex)
        var ogHandlesLiked = uniqueLikes[likeIndex].handlesLiked;
        ogHandlesLiked.push(likeO.userHandle);
        uniqueLikes[likeIndex].handlesLiked = ogHandlesLiked;      
        }        
    });  
    
    return {
        ...state,
        //posts: action.payload,
        allPosts: action.payload.allPosts,
        likes: uniqueLikes,
        currentPost: {},
        currentProfile: {},
        //loading: false,
      };
    case SET_POST:
      return {
        ...state,
        currentPost: action.payload,
        currentProfile: {},
      };
    // case SET_SAVED_POSTS:
    //   return {
    //     ...state,
    //     savedPosts: action.payload,
    //     loading: false,
    //   };
    case LIKE_POST:
      let index = state.likes.findIndex(
        (post) => post.postId === action.payload.postId
      );
      //* Should be already in 'likes' variable since POST_POST creates new element in 'likes'
      if(index === -1) {
        state.likes = [...state.likes, {
          postId: action.payload.postId,
          handlesLiked: [action.payload.likeHandle]
        }];
      }
      else {
        var newhandlesLiked = state.likes[index].handlesLiked;
        newhandlesLiked.push(action.payload.likeHandle);
        state.likes[index] = {...state.likes[index],
          handlesLiked: newhandlesLiked,
        }
      }
      return {
        ...state,
      };

    case UNLIKE_POST:
      var pIndex = state.likes.findIndex(
        (post) => post.postId === action.payload.postId
      );
      state.likes[pIndex] = {...state.likes[pIndex],
        handlesLiked: state.likes[pIndex].handlesLiked.filter(
          (handle) => handle !== action.payload.userHandle
        ),
      }
      // // get the post based on the action's postId and get the count from that
      // let index = state.allPosts.findIndex(
      //   (post) => post.postId === action.payload.postId
      // );
      // state.posts[index] = action.payload;
      // if (state.post.postId === action.payload.postId) {
      //   // action.payload does not contain comments so we need to spread state.post to keep them.
      //   // Otherwise app will break when we like a post from the PostDialog.
      //   state.post = { ...state.post, ...action.payload };
      // }
      return {
        ...state,
      };
    case DELETE_POST:
      index = state.allPosts.findIndex((post) => post.postId === action.payload);
      state.allPosts.splice(index, 1);
      return {
        ...state,
      };
    case POST_POST:
      return {
        ...state,
        allPosts: [action.payload, ...state.allPosts],
        likes: [...state.likes, {
              postId: action.payload.postId,
              handlesLiked: [],
            }],
      };
    case SUBMIT_COMMENT:
      // update comment count in the post component
      let commentedOnIndex = state.allPosts.findIndex(
        (post) => post.postId === action.payload.postId
      );
      return {
        ...state,
        currentPost: {
          ...state.currentPost,
          comments: [action.payload, ...state.currentPost.comments],
          commentCount: state.currentPost.commentCount + 1,
        },
        allPosts: state.allPosts.map((post, postsArrIndex) =>
          postsArrIndex === commentedOnIndex
            ? { ...post, commentCount: post.commentCount + 1 }
            : post
        ),
      };
      case SET_PROFILE:
        return {
          ...state,        
          currentProfile: action.payload,
        }


    default:
      return state;
  }
}
